var FcSearchManyInputModule = /** @class */ (function () {
    function FcSearchManyInputModule() {
    }
    return FcSearchManyInputModule;
}());
export { FcSearchManyInputModule };
